import { createModel } from "@@/package/utils/ModelUtil";
import Model from "@@/package/mapper/Model";
import {AssessmentTaskResultModel} from "~~/package/mapper/assessment/model/AssessmentTaskResultModel";

export class AssessmentResultDetailModel extends Model {
  constructor(
      public assessmentId: number = 0,
      public score: number = 0,
      public assessmentTaskResultVOList: AssessmentTaskResultModel[] = [],
      public createdAt: number = new Date().getTime()
  ) {
    super();
  }

  public static create(model: Partial<AssessmentResultDetailModel>): AssessmentResultDetailModel {
    return createModel<AssessmentResultDetailModel>(AssessmentResultDetailModel, {
      ...model
    });
  }
}
